import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = "https://flood-forecast-yadn.onrender.com/top-forecasts";

// 🎨 Fixed color palette for consistency
const colorPalette = ['#5c001aff', '#513d49ff', '#45b7d1', '#96ceb4', '#feca57'];

export const useForecastData = () => {
  const [doughnutData, setDoughnutData] = useState([]);
  const [lineData, setLineData] = useState([]);
  const [locations, setLocations] = useState([]);
  const [colorMap, setColorMap] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(BACKEND_URL);
        const data = res.data;

        // Sort by current (first forecast) FSI
        const topLocations = [...data]
          .sort((a, b) => b.forecast[0].fsi - a.forecast[0].fsi)
          .slice(0, 5);

        const locationNames = topLocations.map((d) => d.location);
        setLocations(locationNames);

        // ✅ Build consistent color map
        const map = {};
        locationNames.forEach((loc, index) => {
          map[loc] = colorPalette[index % colorPalette.length];
        });
        setColorMap(map);

        // 🟠 Doughnut chart data
        const doughnut = topLocations.map((loc) => ({
          name: loc.location,
          value: loc.forecast[0].fsi,
          color: map[loc.location],
        }));
        setDoughnutData(doughnut);

        // 🔵 Line chart data: transform forecast points by timestamp
        const allTimestamps = Array.from(
          new Set(topLocations.flatMap((loc) => loc.forecast.map((f) => f.timestamp)))
        ).sort();

        // const lines = allTimestamps.map((timestamp) => {
        //   const entry = { timestamp };
        //   topLocations.forEach((loc) => {
        //     const point = loc.forecast.find((f) => f.timestamp === timestamp);
        //     entry[loc.location] = point ? point.fsi : null;
        //   });
        //   return entry;
        // });

        const lines = allTimestamps.map((timestamp) => {
        const date = new Date(timestamp);
        // const day = date.toLocaleDateString('en-US', { weekday: 'short' }); // e.g., "Mon"
        const day = date.toLocaleDateString('en-US', { weekday: 'short' }); // "Tue"
        const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }); // "3:00 PM"
        const label = `${day}-${time.toLowerCase()}`; // "Tue-3:00 pm"

        const entry = { time: label }; // ⬅️ Rename key for X-axis

        topLocations.forEach((loc) => {
          const point = loc.forecast.find((f) => f.timestamp === timestamp);
          entry[loc.location] = point ? point.fsi : null;
          });
          return entry;
        });


        setLineData(lines);
      } catch (err) {
        console.error("Error fetching forecast data:", err);
      }
    };

    fetchData();
  }, []);

  return { doughnutData, lineData, locations, colorMap };
};
